import { getPointsDistance } from '../utils/distance';
import { INTERSECTION_TYPE } from '../constants';
const getLineParams = (line) => {
    if (!line)
        return null;
    const a = line[0][1] - line[1][1];
    const b = line[1][0] - line[0][0];
    const c = -a * line[0][0] - b * line[0][1];
    return { a, b, c };
};
export const getLinesIntersection = (line1coordinates, line2coordinates) => {
    const line1 = getLineParams(line1coordinates);
    const line2 = getLineParams(line2coordinates);
    if (!line1 || !line2)
        return null;
    let x, y;
    if (line2.a === 0) {
        if (line2.b === 0 || line1.a === 0) {
            return null;
        }
        y = -line2.c / line2.b;
        x = (-line1.b * y - line1.c) / line1.a;
    }
    else {
        const q = line1.a / line2.a;
        const p = line1.b - q * line2.b;
        if (p === 0) {
            return null;
        }
        y = (q * line2.c - line1.c) / p;
        x = (-line2.b * y - line2.c) / line2.a;
    }
    return [parseFloat(`${x}`), parseFloat(`${y}`)]; // because of -0 value
};
// typ 1 = vzd od posledniho < vzdalenost od predposledniho && jeden z nich je delsi nez puvodni segment = prodlouzeni = zdanlivy prusecik
// typ 2 = vzd od posledniho > vzdalenost od predposledniho && jeden z nich je delsi nez puvodni segment = uriznuti v predposlednim vertexu a napojeni nove casti  = zdanlivy prusecik
// typ 3 = oba (od predposledniho a od posledniho) jsou kratsi nez delka segmentu = uriznuti = skutecny prusecik
export const getIntersectionType = (segment, intersectionPoint, isSegmentBilateral) => {
    if (!segment || !intersectionPoint)
        return INTERSECTION_TYPE.NONE;
    const segmentPointsDist = getPointsDistance(segment[0], segment[1]);
    const lastToIntersectionDist = getPointsDistance(segment[1], intersectionPoint);
    const firstToIntersectionDist = getPointsDistance(segment[0], intersectionPoint);
    if (firstToIntersectionDist > segmentPointsDist || lastToIntersectionDist > segmentPointsDist) {
        return firstToIntersectionDist > lastToIntersectionDist && !isSegmentBilateral
            ? INTERSECTION_TYPE.REPLACE
            : INTERSECTION_TYPE.EXTEND;
    }
    return INTERSECTION_TYPE.CROP;
};
//# sourceMappingURL=getLinesIntersection.js.map